<template>

<div class="modal fade" id="modalParahitaRun" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border-0">
        <div>
          <h5 class="modal-title fw-700 fs-18">Isi Identitas</h5>
          <p class="modal-subtitle fw-400 fs-14 lh-20 color-neutral-600 mb-0">Yuk isi form di bawah ini untuk ikut event promo ini</p>
        </div>
      </div>
      <div class="modal-body pt-0">
        <Form @submit="submitForm" v-slot="{ errors }">
          <!-- Kontak Darurat -->
          <section class="mb-3">
            <label class="fw-400 fs-12 lh-14 color-neutral-600">Kontak Darurat</label>
            <div class="input-group mb-3">
              <VueTelInput
                :value="parahitaRunExtraFormTemp.emergency_contact"
                v-model="parahitaRunExtraFormTemp.emergency_contact"
                name="emergency_contact"
                rules="required"
                mode="international"
                class="form-control"
                :class="{ 'is-invalid': errors.emergency_contact }"
                :inputOptions="{
                  'placeholder': vueTelOption.placeholder
                }"
                :validCharactersOnly="true"
                @input="handleInputEmergencyContact"
              />
              <span class="input-group-text bg-grayscale border-0" :class="{ 'is-invalid': errors.emergency_contact }">
                <div class="show-password" type="button" @click="parahitaRunExtraFormTemp.emergency_contact = ''" :class="{'opacity-0':!parahitaRunExtraFormTemp.emergency_contact}">
                  <i class="ri-close-circle-fill fs-24"></i>
                </div>
              </span>
              <ErrorMessage name="emergency_contact" class="invalid-feedback" />
            </div>
          </section>

          <!-- Golongan Darah -->
          <section class="mb-3">
            <label class="fw-400 fs-12 lh-14 color-neutral-600 mb-2">Golongan Darah</label>
            <div class="d-flex align-items-center gap-4">
              <div class="d-flex align-items-center gap-2">
                <input
                  class="payment-method"
                  type="radio"
                  id="golA"
                  @click="parahitaRunExtraFormTemp.golongan_darah = 'A'"
                  :checked="parahitaRunExtraFormTemp.golongan_darah === 'A'">
                <label class="payment-method-label fw-400 fs-14 lh-18 color-neutral-700" for="golA">A</label>
              </div>
              <div class="d-flex align-items-center gap-2">
                <input
                  class="payment-method"
                  type="radio"
                  id="golB"
                  @click="parahitaRunExtraFormTemp.golongan_darah = 'B'"
                  :checked="parahitaRunExtraFormTemp.golongan_darah === 'B'">
                <label class="payment-method-label fw-400 fs-14 lh-18 color-neutral-700" for="golB">B</label>
              </div>
              <div class="d-flex align-items-center gap-2">
                <input
                  class="payment-method"
                  type="radio"
                  id="golAB"
                  @click="parahitaRunExtraFormTemp.golongan_darah = 'AB'"
                  :checked="parahitaRunExtraFormTemp.golongan_darah === 'AB'">
                <label class="payment-method-label fw-400 fs-14 lh-18 color-neutral-700" for="golAB">AB</label>
              </div>
              <div class="d-flex align-items-center gap-2">
                <input
                  class="payment-method"
                  type="radio"
                  id="golO"
                  @click="parahitaRunExtraFormTemp.golongan_darah = 'O'"
                  :checked="parahitaRunExtraFormTemp.golongan_darah === 'O'">
                <label class="payment-method-label fw-400 fs-14 lh-18 color-neutral-700" for="golO">O</label>
              </div>
            </div>
          </section>

          <!-- Ukuran Kaos -->
          <section class="mb-3">
            <label class="fw-400 fs-12 lh-14 color-neutral-600">Ukuran Kaos</label>
            <div class="input-group mb-3 row-flex justify-content-between gap-1">
              <Field
                v-model="parahitaRunExtraFormTemp.ukuran_baju"
                name="ukuran_baju"
                rules="required"
                v-slot="{ field, handleChange }"
              >
                <select
                  v-bind="field"
                  class="form-select select-form color-neutral-900"
                  :class="{ 'is-invalid': errors.ukuran_baju }"
                  @change="handleChange"
                >
                  <option value="" disabled>Pilih Ukuran Kaos</option>
                  <option value="XS">XS (Lebar 46cm, Panjang 68cm)</option>
                  <option value="S">S (Lebar 48cm, Panjang 70cm)</option>
                  <option value="M">M (Lebar 50cm, Panjang 72cm)</option>
                  <option value="L">L (Lebar 52cm, Panjang 74cm)</option>
                  <option value="XL">XL (Lebar 54cm, Panjang 76cm)</option>
                  <option value="XXL">XXL (Lebar 56cm, Panjang 78cm)</option>
                  <option value="XXXL">XXXL (Lebar 58cm, Panjang 80cm)</option>
                </select>
              </Field>
            </div>
            <ErrorMessage name="ukuran_baju" class="invalid-feedback" />
          </section>

          <!-- Partner Form -->
          <div class="partner-form mt-4" v-if="eventType === 'PARAHITA-RUN-FAMILY'">
            <h5 class="modal-title fw-700 fs-18">Isi identitas anak Anda</h5>

            <!-- Nama Partner -->
            <section class="mb-3">
              <label class="fw-400 fs-12 lh-14 color-neutral-600">Nama Anak</label>
              <div class="input-group">
                <Field
                  v-model="parahitaRunExtraFormTemp.partner"
                  name="partner"
                  rules="required"
                  class="form-control"
                  :class="{ 'is-invalid': errors.partner }"
                  placeholder="Nama Lengkap Anak"
                />
                <span class="input-group-text bg-grayscale border-0" :class="{ 'is-invalid': errors.partner }">
                  <div class="show-password" type="button" @click="parahitaRunExtraFormTemp.partner = ''" :class="{'opacity-0':!parahitaRunExtraFormTemp.partner}">
                    <i class="ri-close-circle-fill fs-24"></i>
                  </div>
                </span>
                <ErrorMessage name="partner" class="invalid-feedback" />
              </div>
            </section>

            <!-- Kontak Darurat Partner -->
            <section class="mb-3">
              <label class="fw-400 fs-12 lh-14 color-neutral-600">Kontak Darurat Anak</label>
              <div class="input-group mb-3">
                <VueTelInput
                  :value="parahitaRunExtraFormTemp.emergency_contact_partner"
                  v-model="parahitaRunExtraFormTemp.emergency_contact_partner"
                  name="emergency_contact_partner"
                  rules="required"
                  mode="international"
                  class="form-control"
                  :class="{ 'is-invalid': errors.emergency_contact_partner }"
                  :inputOptions="{
                    'placeholder': vueTelOption.placeholder
                  }"
                  :validCharactersOnly="true"
                  @input="handleInputEmergencyContactPartner"
                />
                <span class="input-group-text bg-grayscale border-0" :class="{ 'is-invalid': errors.emergency_contact_partner }">
                  <div class="show-password" type="button" @click="parahitaRunExtraFormTemp.emergency_contact_partner = ''" :class="{'opacity-0':!parahitaRunExtraFormTemp.emergency_contact_partner}">
                    <i class="ri-close-circle-fill fs-24"></i>
                  </div>
                </span>
                <ErrorMessage name="emergency_contact_partner" class="invalid-feedback" />
              </div>
            </section>

            <!-- Golongan Darah Partner -->
            <section class="mb-3">
              <label class="fw-400 fs-12 lh-14 color-neutral-600 mb-2">Golongan Darah Anak</label>
              <div class="d-flex align-items-center gap-4">
                <div class="d-flex align-items-center gap-2">
                  <input
                    class="payment-method"
                    type="radio"
                    id="golAPartner"
                    @click="parahitaRunExtraFormTemp.golongan_darah_partner = 'A'"
                    :checked="parahitaRunExtraFormTemp.golongan_darah_partner === 'A'">
                  <label class="payment-method-label fw-400 fs-14 lh-18 color-neutral-700" for="golAPartner">A</label>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <input
                    class="payment-method"
                    type="radio"
                    id="golBPartner"
                    @click="parahitaRunExtraFormTemp.golongan_darah_partner = 'B'"
                    :checked="parahitaRunExtraFormTemp.golongan_darah_partner === 'B'">
                  <label class="payment-method-label fw-400 fs-14 lh-18 color-neutral-700" for="golBPartner">B</label>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <input
                    class="payment-method"
                    type="radio"
                    id="golABPartner"
                    @click="parahitaRunExtraFormTemp.golongan_darah_partner = 'AB'"
                    :checked="parahitaRunExtraFormTemp.golongan_darah_partner === 'AB'">
                  <label class="payment-method-label fw-400 fs-14 lh-18 color-neutral-700" for="golABPartner">AB</label>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <input
                    class="payment-method"
                    type="radio"
                    id="golOPartner"
                    @click="parahitaRunExtraFormTemp.golongan_darah_partner = 'O'"
                    :checked="parahitaRunExtraFormTemp.golongan_darah_partner === 'O'">
                  <label class="payment-method-label fw-400 fs-14 lh-18 color-neutral-700" for="golOPartner">O</label>
                </div>
              </div>
            </section>

            <!-- Ukuran Kaos Partner -->
            <section class="mb-3">
              <label class="fw-400 fs-12 lh-14 color-neutral-600">Ukuran Kaos Anak</label>
              <div class="input-group mb-3 row-flex justify-content-between gap-1">
                <Field
                  v-model="parahitaRunExtraFormTemp.ukuran_baju_partner"
                  name="ukuran_baju_partner"
                  rules="required"
                  v-slot="{ field, handleChange }"
                >
                  <select
                    v-bind="field"
                    class="form-select select-form color-neutral-900"
                    :class="{ 'is-invalid': errors.ukuran_baju_partner }"
                    @change="handleChange"
                  >
                    <option value="" disabled>Pilih Ukuran Kaos</option>
                    <option value="XS">XS (Lebar 32cm, Panjang 46cm)</option>
                    <option value="S">S (Lebar 34cm, Panjang 48cm)</option>
                    <option value="M">M (Lebar 36cm, Panjang 50cm)</option>
                    <option value="L">L (Lebar 38cm, Panjang 53cm)</option>
                    <option value="XL">XL (Lebar 40cm, Panjang 55cm)</option>
                    <option value="2XL">2XL (Lebar 42cm, Panjang 57cm)</option>
                    <option value="3XL">3XL (Lebar 44cm, Panjang 59cm)</option>
                    <option value="4XL">4XL (Lebar 46cm, Panjang 61cm)</option>
                    <option value="5XL">5XL (Lebar 48cm, Panjang 63cm)</option>
                  </select>
                </Field>
              </div>
              <ErrorMessage name="ukuran_baju_partner" class="invalid-feedback" />
            </section>
          </div>

          <div class="modal-footer border-0">
            <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="destroyModal">Batal</button>
            <button
              type="submit"
              class="btn btn-secondary text-white"
              :disabled="isDisabled"
              data-bs-dismiss="modal"
            >
              Lanjutkan
            </button>
          </div>
        </Form>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import { Modal } from 'bootstrap'
import { onMounted, ref, computed } from 'vue'
import { VueTelInput } from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'
import { Field, Form, ErrorMessage } from 'vee-validate'

export default {
  components: {
    VueTelInput,
    Field,
    Form,
    ErrorMessage
  },
  props: {
    parahitaRunExtraForm: {
      type: Object,
      required: true
    },
    eventType: {
      type: String,
      required: true
    }
  },
  emits: ['submit', 'close', 'updateParahitaRunExtraForm'],
  setup (props, { emit }) {
    const parahitaRunExtraFormTemp = ref({ ...props.parahitaRunExtraForm })
    const vueTelOption = ref({
      mode: 'international',
      defaultCountry: 'ID',
      onlyCountries: ['ID'],
      enabledCountryCode: true,
      enabledFlags: true,
      autocomplete: 'off',
      required: true,
      placeholder: 'Contoh: 0812 3456 7890'
    })

    let modal = null

    const isDisabled = computed(() => {
      // Check required fields for main participant
      const mainParticipantRequired = !parahitaRunExtraFormTemp.value.ukuran_baju ||
        !parahitaRunExtraFormTemp.value.emergency_contact ||
        !parahitaRunExtraFormTemp.value.golongan_darah

      // If main participant fields are missing, form is disabled
      if (mainParticipantRequired) {
        return true
      }

      // For family event type, check partner fields
      if (props.eventType === 'PARAHITA-RUN-FAMILY') {
        const partnerRequired = !parahitaRunExtraFormTemp.value.partner ||
          !parahitaRunExtraFormTemp.value.ukuran_baju_partner ||
          !parahitaRunExtraFormTemp.value.emergency_contact_partner ||
          !parahitaRunExtraFormTemp.value.golongan_darah_partner

        return partnerRequired
      }

      return false
    })

    const handleInputEmergencyContact = (phone, phoneObject) => {
      if (phoneObject?.formatted) {
        parahitaRunExtraFormTemp.value.emergency_contact = phoneObject.formatted
      }
    }

    const handleInputEmergencyContactPartner = (phone, phoneObject) => {
      if (phoneObject?.formatted) {
        parahitaRunExtraFormTemp.value.emergency_contact_partner = phoneObject.formatted
      }
    }

    const destroyModal = () => {
      emit('updateParahitaRunExtraForm', parahitaRunExtraFormTemp.value)
      emit('close')
    }

    const submitForm = () => {
      emit('updateParahitaRunExtraForm', parahitaRunExtraFormTemp.value)
      emit('submit')
    }

    const showModal = () => {
      const modalElement = document.getElementById('modalParahitaRun')
      if (modalElement) {
        modal = new Modal(modalElement)
        modal.show()
      }
    }

    onMounted(() => {
      showModal()
    })

    return {
      parahitaRunExtraFormTemp,
      vueTelOption,
      handleInputEmergencyContact,
      handleInputEmergencyContactPartner,
      destroyModal,
      showModal,
      isDisabled,
      submitForm
    }
  }
}

</script>

<style scoped lang="scss">
@import '../../assets/scss/variables.scss';

.modal-content {
  border-radius: 10px;
  border: none;
}

.form-control, .input-group-text {
  background: none;
  border-radius: 0;
  box-shadow: inset 0px -1px 0px rgba(242, 242, 242, 0.8);
  padding: 8px 4px 8px 0px;
  font-size: 18px;
  border: none;
}

.form-control::placeholder {
  color: #CBD5E0;
}

.form-control.is-invalid, .input-group-text.is-invalid {
  box-shadow: inset 0px -1px 0px #E21F39;
}

.input-group>.form-control.form-error {
  background: #FFDDEB;
  color: #14142B;
}

select.select-form {
  height: 100%;
  font-size: 18px;
  line-height: 24px;
  border: none;
  box-shadow: 0px -1px 0px 0px #F2F2F2CC inset;
  background-image: url("../../assets/icon/select-arrow.png");
  background-repeat: no-repeat;
  background-size: 14px auto;
  padding-right: 30px;
  background-position: right center;
}

.payment-method {
  width: 24px;
  height: 24px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: 2px solid #718096;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  background-color: white;

  &-label:active {
    color: #4A5568;
  }
}

.payment-method:checked {
  background-color: white;
  border-color: $secondary;
}

.payment-method:checked::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 13px;
  height: 13px;
  background-color: $secondary;
  border-radius: 50%;
}
</style>
